export type FaqItem = { question: string; answer: string };

const requestIsNotBooking: FaqItem = {
  question: 'Заявка — это уже бронь?',
  answer: 'Нет. Заявка — запрос на связь: она не резервирует дату и не подтверждает участие. Организатор свяжется с вами, и участие подтверждается только после того, как вы вместе согласуете дату, время, программу и стоимость.',
};

const payment: FaqItem = {
  question: 'Как оплатить экскурсию?',
  answer: 'Стоимость и порядок оплаты согласуем с организатором после заявки. Не вносите оплату до того, как получите согласованные условия и реквизиты, — отправка формы оплатой не является.',
};

const cancellation: FaqItem = {
  question: 'Что делать, если планы изменились?',
  answer: 'Напишите или позвоните организатору как можно раньше. Условия переноса и отмены согласуются отдельно до подтверждения участия — уточните их, когда будете обсуждать дату.',
};

const duration = (where: string): FaqItem => ({
  question: 'Сколько длится экскурсия?',
  answer: `Ориентировочная длительность указана ${where}. Точное время начала и окончания подтвердим при согласовании — оно зависит от программы, группы и правил площадки.`,
});

const depotClothes: FaqItem = {
  question: 'Что надеть в депо?',
  answer: 'Удобную закрытую обувь и одежду, в которой не жалко пройти по действующей территории. Требования площадки к одежде и место встречи пришлём заранее, перед экскурсией.',
};

const depotChildren: FaqItem = {
  question: 'Можно ли прийти с детьми?',
  answer: 'Да, с детьми можно. Ориентир по возрасту — в карточке экскурсии. Допустимый возраст и число сопровождающих согласуем по правилам депо. Дети остаются под присмотром родителей или сопровождающих; на территории все участники соблюдают инструктаж.',
};

const tramClothes: FaqItem = {
  question: 'Что взять с собой?',
  answer: 'Удобную одежду по погоде и хорошее настроение. Место и время посадки, а также правила поездки пришлём заранее, после согласования.',
};

const tramChildren: FaqItem = {
  question: 'Можно ли поехать с детьми?',
  answer: 'Да. Ориентир по возрасту — в карточке экскурсии; число сопровождающих для детской группы согласуем заранее. Посадка, высадка и поездка проходят только по указаниям ответственных лиц.',
};

const factsCard = 'в карточке экскурсии на этой странице';

export const faqByPath: Record<string, FaqItem[]> = {
  '/': [
    {
      question: 'Как записаться на экскурсию?',
      answer: 'Нажмите «Оставить заявку», выберите экскурсию и формат — групповой или индивидуальный — и оставьте телефон или ник в мессенджере. Организатор свяжется с вами, чтобы обсудить детали.',
    },
    requestIsNotBooking,
    {
      question: 'Чем групповая экскурсия отличается от индивидуальной?',
      answer: 'Групповая — для вашей уже собранной группы: класса, студентов, коллег или друзей. Индивидуальная — для вас одного, семьи или близкого круга. В обоих случаях это отдельная экскурсия для вашей компании, без присоединения к незнакомым людям.',
    },
    duration('на странице каждой экскурсии'),
    {
      question: 'Можно ли прийти с детьми?',
      answer: 'Да. Ориентир по возрасту указан на странице каждой экскурсии, а допустимый возраст и число сопровождающих согласуем по правилам выбранной площадки.',
    },
    payment,
  ],
  '/shkolam': [
    {
      question: 'Какую экскурсию выбрать для класса?',
      answer: 'Ориентир по возрасту указан в карточке каждой экскурсии. Если сомневаетесь, напишите в комментарии к заявке возраст учеников и тему, которую хотите затронуть, — подскажем подходящий вариант.',
    },
    {
      question: 'Сколько нужно сопровождающих?',
      answer: 'Число сопровождающих зависит от возраста учеников и правил площадки — его согласуем заранее. Во время экскурсии дети остаются под присмотром учителей или согласованных сопровождающих.',
    },
    requestIsNotBooking,
    {
      question: 'Что делать, если дату нужно перенести?',
      answer: 'Сообщите организатору как можно раньше. Условия переноса и отмены согласуются отдельно до подтверждения участия.',
    },
  ],
  '/excursions/kttu': [
    {
      question: 'Какую экскурсию КТТУ выбрать?',
      answer: 'Если хочется заглянуть за ворота и увидеть, где транспорт проводит время между рейсами, — выбирайте депо. Если интереснее посмотреть на город — поездку на трамвае. Для праздника подойдёт «Караоке на колёсах». Сомневаетесь — оставьте заявку, обсудим вместе.',
    },
    duration('на странице каждой экскурсии'),
    {
      question: 'Можно ли прийти с детьми?',
      answer: 'Да. Ориентир по возрасту — на странице каждой экскурсии. Допустимый возраст и число сопровождающих согласуем по правилам площадки.',
    },
    depotClothes,
    payment,
    requestIsNotBooking,
  ],
  '/excursions/vostochnoe-tramvaynoe-depo': [
    depotClothes,
    depotChildren,
    duration(factsCard),
    payment,
    cancellation,
    requestIsNotBooking,
  ],
  '/excursions/zapadnoe-tramvaynoe-depo': [
    depotClothes,
    depotChildren,
    duration(factsCard),
    payment,
    cancellation,
    requestIsNotBooking,
  ],
  '/excursions/pervoe-trolleybusnoe-depo': [
    depotClothes,
    depotChildren,
    duration(factsCard),
    payment,
    cancellation,
    requestIsNotBooking,
  ],
  '/excursions/tramvay-po-gorodu': [
    tramClothes,
    tramChildren,
    duration(factsCard),
    payment,
    cancellation,
    requestIsNotBooking,
  ],
  '/excursions/tramvay-nestandartnyy-marshrut': [
    {
      question: 'Можно ли выбрать маршрут самостоятельно?',
      answer: 'Расскажите в заявке, что хочется увидеть и о чём поговорить. Возможный маршрут и программу согласуем с организатором — они зависят от возможностей перевозчика, поэтому пожелания не гарантируют конкретный маршрут.',
    },
    tramChildren,
    duration(factsCard),
    payment,
    cancellation,
    requestIsNotBooking,
  ],
  '/excursions/karaoke-na-kolesah': [
    {
      question: 'Нужно ли уметь петь?',
      answer: 'Нет. Это повод провести время вместе и посмотреть на город, а не конкурс вокалистов. Подпевать или слушать — выбирайте сами.',
    },
    {
      question: 'Можно ли с детьми?',
      answer: 'Ориентир по возрасту указан в карточке экскурсии. Состав компании и число сопровождающих обсудим при согласовании.',
    },
    duration(factsCard),
    payment,
    cancellation,
    requestIsNotBooking,
  ],
  '/excursions/botanicheskaya-progulka': [
    {
      question: 'Что надеть на прогулку?',
      answer: 'Удобную обувь и одежду по погоде. Место встречи и подсказки к подготовке пришлём заранее, после согласования парка и даты.',
    },
    {
      question: 'Можно ли прийти с детьми?',
      answer: 'Да. Ориентир по возрасту — в карточке экскурсии. Дети остаются под присмотром родителей или сопровождающих.',
    },
    {
      question: 'Можно ли собирать растения для гербария?',
      answer: 'Только там и в том объёме, где это разрешено правилами парка и экскурсоводом. Где сбор запрещён, ограничимся наблюдениями и фотографиями.',
    },
    {
      question: 'Как выбрать парк?',
      answer: 'Укажите предпочтительный парк в заявке. Место согласуем с организатором заранее — пожелание не гарантирует проведение именно в этом парке.',
    },
    duration(factsCard),
    payment,
  ],
};
